var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from 'react';
import { styled } from 'styled-components';
import { markCardsAsSeen } from './api';
import { CardList } from './CardList';
import { Title } from '../Common';
import { Container, TitleContainer, ArrowIcon, Summary } from './Common';
var ScCardList = styled(CardList).withConfig({ displayName: "ScCardList", componentId: "sc-hds51s" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #f3faff;\n"], ["\n  background: #f3faff;\n"])));
var ScTitle = styled(Title).withConfig({ displayName: "ScTitle", componentId: "sc-90y2al" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var TopicItem = function (_a) {
    var streamData = _a.streamData, studentId = _a.studentId, isWeekly = _a.isWeekly, onExpand = _a.onExpand, rest = __rest(_a, ["streamData", "studentId", "isWeekly", "onExpand"]);
    var title = streamData.title, summary = streamData.summary, seenSummary = streamData.seenSummary, cards = streamData.cards, deletedCards = streamData.deletedCards, activeStruggleCards = streamData.activeStruggleCards;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(0), clickCount = _c[0], setClickCount = _c[1];
    var _d = useState(summary), summaryInner = _d[0], setSummaryInner = _d[1];
    var onOpenTopic = useCallback(function () {
        if (!isOpen)
            onExpand === null || onExpand === void 0 ? void 0 : onExpand();
        setIsOpen(!isOpen);
        setClickCount(function (value) { return value + 1; });
    }, [isOpen, onExpand]);
    useEffect(function () {
        if (isOpen)
            markCardsAsSeen({ studentId: studentId, activeStruggleCards: activeStruggleCards });
    }, [isOpen, studentId, activeStruggleCards]);
    useEffect(function () {
        if (clickCount >= 2)
            setSummaryInner(seenSummary);
    }, [clickCount, seenSummary]);
    return (_jsxs(_Fragment, { children: [_jsxs(Container, __assign({}, rest, { onClick: onOpenTopic, role: 'listitem' }, { children: [_jsxs(TitleContainer, { children: [_jsx(ScTitle, { children: title }, void 0), _jsx(ArrowIcon, { "data-testid": 'arrow icon', open: isOpen }, void 0)] }, void 0), _jsx(Summary, { dangerouslySetInnerHTML: { __html: summaryInner } }, void 0)] }), void 0), isOpen && cards && (_jsx(ScCardList, { deletedCards: deletedCards, cards: cards, activeStruggleCards: activeStruggleCards, wasSeen: clickCount >= 2, isWeekly: isWeekly }, void 0))] }, void 0));
};
export { TopicItem };
var templateObject_1, templateObject_2;
